function WbAddressLookupService($http, $q) {
    'ngInject';

    return {
        lookupPostcode(postcode) {
            var request = {
                "id": "1",
                "method": "addressInternalExternal",
                "params": {
                    "postcode": postcode
                },
                "jsonrpc": "2.0"
            };

            return $http({
                url: '/ajaxlibrary',
                method: 'POST',
                data: request,
                headers: { 'Content-Type': 'application/json;charset=utf-8' }
            }).then(response => {
                if (response.data.error) {
                    return $q.reject("Please enter a valid postcode");
                } else if (response.data.result) {
                    if (!response.data.result.rows || response.data.result.rows.length === 0) {
                        return $q.reject(`No address found for postcode ${postcode}`);
                    }
                    // Filter out nulls and return
                    return response.data.result.rows.filter(row => row);
                }
            });
        }
    };
}

angular
    .module('westBerkshireEvents.addressLookup')
    .service('WbAddressLookupService', WbAddressLookupService);


// WEBPACK FOOTER //
// ../src/public/javascripts/address-lookup/address_lookup.service.js